import { Button, Div, H3, Modal, P, PropsModal } from '@vgrubs/components';

export const ClaimDeliveryModal = ({
  modalIsOpen,
  closeModal,
  handleClaimDelivery,
}: PropsModal & {
  modalIsOpen: number | null;
  handleClaimDelivery: (id: number) => void;
}) => {
  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      zIndex={110}
      width="400px"
    >
      <H3 $mb="8">Dispatcher: Claim It</H3>
      <P $mb="24">Are you sure you want to claim this delivery?</P>

      <Div $flex $gap="16px">
        <Button
          $selected
          $w="100%"
          onClick={() => handleClaimDelivery(modalIsOpen ?? 0)}
        >
          Confirm
        </Button>

        <Button $selected $w="100%" $gray onClick={() => closeModal?.()}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
